import { MetricDataPoint, Periods, timeRangeToStepsParams } from 'cio/utils/metrics/common';
import { JourneyMetrics, APIJourneyMetricsMeasure, METRICS as MEASURES } from 'cio/utils/journey-metrics';
import { SECONDS_IN_DAY } from 'cio/utils/constants';
import { Grouping } from 'cio/utils/metrics/resolution';
import { TimeRange } from 'cio/utils/time';

export function deserialize(
  data: {
    data: Record<APIJourneyMetricsMeasure, number[]>;
  },
  _resolution: Periods | null,
  grouping: Grouping | null,
  range: TimeRange,
  timezone = 'Etc/GMT+4',
) {
  if (range.start == null || range.end == null) {
    throw new Error('Time range must have both start and end timestamps');
  }

  let requestedRange = timeRangeToStepsParams(range, timezone);
  let timestampedData: Record<APIJourneyMetricsMeasure, MetricDataPoint[]> = {
    started: [],
    activated: [],
    messaged: [],
    finished: [],
    exited_early: [],
    never_activated: [],
    converted: [],
  };

  if (requestedRange?.steps != null && requestedRange?.start != null) {
    let { start, steps } = requestedRange;
    let timestamps = [start, ...[...new Array(steps)].map((_, i) => start + (i + 1) * SECONDS_IN_DAY)];

    MEASURES.forEach((measure) => {
      let measureData: MetricDataPoint[] = timestamps.map((timestamp, i) => ({
        x: timestamp * 1000,
        y: data.data[measure]?.[i],
      }));

      timestampedData[measure] = measureData;
    });
  }

  return new JourneyMetrics({
    data: data.data,
    timestampedData,
    startTime: range.start,
    endTime: range.end,
    grouping: grouping ?? Grouping.Daily,
    timezone,
  });
}
